// extracted by mini-css-extract-plugin
module.exports = {"user-avatar":"style_user-avatar__1p62C","user-name-intials":"style_user-name-intials__cqhfv","active":"style_active__3Mmbp","hovering":"style_hovering__Ay4Qd"};